<template id="vue_gnosisSmartyStreetsVUE">
    <div class="addressVerification--error" v-if="!!errorMessage">
      <span>{{ errorMessage }}</span>
    </div>  
    <div v-else>
    <ol class="rounded-list rounded-list-hoverscale" >
      <li
        v-for="candidate in candidates"
        :key="candidate.candidateIndex"
        v-bind:class="'addressVerification--candidate'"
        v-on:click="selectCandidate(candidate)"
      >
        <a>
          <div v-if="candidate.address1">{{ candidate.address1 }}</div>
          <div v-if="candidate.address2">{{ candidate.address2 }}</div>
          <div>
            {{
              [candidate.city, candidate.state, candidate.zipCode]
                .filter(function (val) {
                  return val;
                })
                .join(", ")
            }}
          </div>
        </a>
      </li>
    </ol>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    candidates: Array,
    errorMessage: String,
  },
  methods: {
    selectCandidate(address) {
      this.$emit("selected", address);
    },
  },
};
</script>
<style>
ol.rounded-list {
  counter-reset: li; /* Initiate a counter */
  list-style: none; /* Remove default numbering */
  font: 15px "trebuchet MS", "lucida sans";
  padding: 0;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
}

ol.rounded-list ol {
  margin: 0 0 0 2em; /* Add some left margin for inner lists */
}

.addressVerification--error {
  background-color: peachpuff;
  text-align: center;
}

.addressVerification--candidate {
  padding: 5px 20px;
  padding-left: 30px;
}

ol.rounded-list a {
  position: relative;
  display: block;
  padding: 0.4em 0.4em 0.4em 2em;
  margin: 0.5em 0;
  background: #ddd;
  color: #444;
  text-decoration: none;
  border-radius: 0.3em;
  transition: all 0.3s ease-out;
}

ol.rounded-list a:hover {
  background: #eee;
  background-color: rgb(224, 217, 240);
  color: #02355a;
  cursor: pointer;
}

ol.rounded-list a:before {
  content: counter(li);
  counter-increment: li;
  position: absolute;
  left: -1.3em;
  top: 50%;
  margin-top: -1.3em;
  background: #87ceeb;
  height: 2.5em;
  width: 2.5em;
  line-height: 2em;
  border: 0.3em solid #fff;
  text-align: center;
  font-weight: 700;
  border-radius: 2em;
  box-sizing: border-box;
}
ol.rounded-list.rounded-list-hoverscale-pulse a:hover:before {
  animation: pulse 0.5s 1;
  transform: scale(1.33);
  transition: all 0.3s ease-out;
}
ol.rounded-list.rounded-list-hoverscale a:hover:before {
  transform: scale(1.33);
  transition: all 0.3s ease-out;
}
@keyframes pulse {
  0%,
  100% {
    animation-timing-function: ease-in;
  }

  50% {
    transform: scale(1.33);
  }
}
</style>